const initialState = () => ({
  tasks: [],
  pagination: {
    page: 1,
    rowsPerPage: 7,
    rowsNumber: 0
  },
  actionPlan: null,
  loading: false,
  task: [],
  creator_users: [],
  tags: [],
  tags2: [],
  tags3: [],
  tags4: [],
  taskQuery: {
    ocurrenceId: null,
    itemId: null,
    taskId: null,
    state: null,
    role: null,
    users: [],
    location_id: [],
    endDate: null,
    priority: null,
    title: null,
    category: null,
    category2: null,
    comment: null,
    pictures: [],
    enforceEvidence: null,
    short_name: null,
    area_id: null,
    hierarchy_site_id: null,
    hierarchy_subcategory_id: null
  },
  actionPlans: []
})

export default initialState
